// File: `app/javascript/controllers/product_module/bike.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';
import {create_array_for_product} from "../b2b_controller";
import {get_contract} from "../rentaContractModalityTariff_controller";
import {setSessionVar} from "../sessionStorage_controller";
import {modalities, modality_info} from "../preferences_controller";
import {extractTimeValues, setupOfficeHelper} from "./office_helper";
import {withElementBlock} from "../blockUI_controller";

export function initBike(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        setSessionVar,
        get_contract,
        get_tariffs,
        get_modalities,
        verify_season,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        locale,
        sessionStorage,
        year,
        month,
        day,
        hour,
        minutes
    } = deps;

    if (!form_type_send) return;

    // Selectores
    let bike_to = $('#bike_to');
    let bike_select_collect = $('#bike_collect_place');
    let bike_select_delivery = $('#bike_delivery_place');
    let bike_date_collect = $('#bike_date_collect');
    let bike_date_delivery = $('#bike_date_delivery');
    let bike_time_collect = $('#bike_time_collect');
    let bike_time_delivery = $('#bike_time_delivery');
    let bike_collect = bike_select_collect.prop('disabled', true).select2({
        theme: "bootstrap", placeholder: I18n.t('global.main.form.select_office')
    });
    let bike_delivery = bike_select_delivery.prop('disabled', true).select2({
        theme: "bootstrap", placeholder: I18n.t('global.main.form.select_office')
    });
    let bike_category = $('#bike_category').prop('disabled', true).select2({
        theme: "bootstrap", placeholder: I18n.t('global.main.form.select_category')
    });

    // Destinos
    bike_to.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: `${location.origin}/${locale.locale}/destination`,
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                };
            },
            type: 'GET',
            processResults: function (data, params) {
                let result = [];
                params.page = params.page || 1;
                (data.rows || []).forEach(elem => {
                    result.push({ id: `${elem.code}|${elem.id}`, text: elem.name });
                });
                const total = data.total || 0;
                return {
                    results: result,
                    pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                };
            }
        }
    }).on('change', function (e) {
        // limpiar
        bike_collect.empty();
        bike_delivery.empty();
        bike_category.empty();

        const split = (e.target.value || '').split('|');
        const bike_destino = split[0];
        const destino_id = split[1];

        create_array_for_product('product_type', form_type_send[0].value);
        create_array_for_product('destination', bike_destino);
        create_array_for_product('amount', 1);
        create_array_for_product('pax', 1);
        create_array_for_product('destination_id', destino_id);
        create_array_for_product('text_destination', $(e.target).select2('data')[0].text);

        // FIX (2026-08-10): se RESTAURA el select2 perezoso original (AJAX al abrir/buscar).
        // La precarga con data: rompía el flujo real (las peticiones por detrás se disparan
        // al abrir/seleccionar la oficina). El bloqueo + aviso se maneja en los handlers.
        bike_delivery.select2({
            theme: "bootstrap",
            language: "es",
            placeholder: I18n.t('global.main.form.select_office'),
            ajax: {
                url: `${location.origin}/${locale.locale}/office_by_destination`,
                data: function (params) {
                    return {
                        search: params.term,
                        page: params.page || 1,
                        destination: destino_id,
                        type: form_type_send[0].dataset.type
                    };
                },
                type: "GET",
                processResults: function (data, params) {
                    return { results: buildOfficeResults(data) };
                }
            }
        }).prop("disabled", false).off('change').on('change', onDeliveryChange);

        bike_collect.select2({
            theme: "bootstrap",
            language: "es",
            placeholder: I18n.t('global.main.form.select_office'),
            ajax: {
                url: `${location.origin}/${locale.locale}/office_by_destination`,
                data: function (params) {
                    return {
                        search: params.term,
                        page: params.page || 1,
                        destination: destino_id,
                        type: form_type_send[0].dataset.type
                    };
                },
                type: "GET",
                processResults: function (data, params) {
                    return { results: buildOfficeResults(data) };
                }
            }
        }).prop("disabled", false).off('change').on('change', onCollectChange);
    });

    // FIX (2026-08-10): mapeo de oficinas extraído de processResults (precarga del destino).
    function buildOfficeResults(data) {
        let result = [];
        (data.offices || []).forEach(elem => {
            let aux = { text: elem.dealer_name, children: [] };
            if (elem.offices && elem.offices.length > 0) {
                elem.offices.forEach(child => {
                    if (child.active) {
                        aux.children.push({
                            id: `${child.code}-dealer:${elem.dealer_code}-dealer_name:${elem.dealer_name.replace(/-/g, '_')}-full_time:${child.full_time}-open_time:${child.open_time}-close_time:${child.close_time}`,
                            text: child.name
                        });
                    }
                });
            }
            if (aux.children.length > 0) result.push(aux);
        });
        if (result.length === 0) {
            result.push({ text: "No hay datos para mostrar", children: [] });
        }
        return result;
    }

    // Entrega
    function onDeliveryChange(e) {
        let bike_entrega = e.target.value.split('-');
        create_array_for_product('drop_off_place', bike_entrega[0]);
        create_array_for_product('delivery_place_text', $(e.target).select2('data')[0].text);

        setupOfficeHelper(bike_delivery, e.target.value, I18n);

        const { openTime, closeTime } = extractTimeValues(e.target.value);
        create_array_for_product('open_time', openTime);
        create_array_for_product('close_time', closeTime);

        /*let helper_delivery = $(bike_delivery[0].parentNode).find('.helper-text');
        let tootltip_button_delivery = $(bike_delivery[0].parentNode).find('.tooltip-button');
        let text_helper = '';
        let full_time = bike_entrega[3].split('full_time:')[1];
        if (full_time === "false") {
            let from = bike_entrega[4].split('open_time:')[1] + ":00am";
            let to = (parseInt(bike_entrega[5].split("close_time:")[1]) - 12) + ":00pm";
            create_array_for_product('open_time', (bike_entrega[4].split('open_time:')[1].length === 1 ? `0${bike_entrega[4].split('open_time:')[1]}` : bike_entrega[4].split('open_time:')[1]));
            create_array_for_product('close_time', (bike_entrega[5].split('close_time:')[1].length === 1 ? `0${bike_entrega[5].split('close_time:')[1]}` : bike_entrega[5].split('close_time:')[1]));
            text_helper = I18n.t('global.main.form.work_by_hours', { from: from, to: to });
        } else {
            text_helper = I18n.t('global.main.form.work_all_day');
        }
        helper_delivery.text(text_helper);
        tootltip_button_delivery[0].classList.remove('hide-tooltip');*/

        // FIX (2026-08-10): pre-calentar contrato+tarifa con bloqueo (solo si ya hay dealer).
        const dealer_actual = create_array_for_product('dealer', '', 'show');
        if (dealer_actual !== undefined) {
            withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'), new Promise((resolve) => {
                // get_contract/get_tariffs SIN box_block: el withElementBlock ya cubre el overlay
                // y evita el unblock prematuro del helper; el helper ya avisa con toastr en error.
                get_contract(null, dealer_actual).then(gcontract => {
                    if (!gcontract.next) {
                        resolve();
                        return;
                    }
                    get_tariffs(null).then(() => {
                        resolve();
                    });
                });
            }), { timeout: 30000 });
        }
    }

    // Recogida: bloquea hasta que terminen TODAS las llamadas por detrás.
    function onCollectChange(e) {
        let bike_recogida = e.target.value.split('-');

        bike_time_collect.prop('readonly', true);

        create_array_for_product('pick_up_place', bike_recogida[0]);
        create_array_for_product('dealer', bike_recogida[1].split('dealer:')[1]);
        create_array_for_product('dealer_name', bike_recogida[2].split('dealer_name:')[1]);
        create_array_for_product('collect_place_text', $(e.target).select2('data')[0].text);

        setupOfficeHelper(bike_collect, e.target.value, I18n);

        const { openTime, closeTime } = extractTimeValues(e.target.value);
        create_array_for_product('open_time_collect', openTime);
        create_array_for_product('close_time_collect', closeTime);

        /*let helper_collect = $(bike_collect[0].parentNode).find('.helper-text');
        let tootltip_button_collect = $(bike_collect[0].parentNode).find('.tooltip-button');
        let text_helper_collect = '';
        let full_time_collect = bike_recogida[3].split('full_time:')[1];
        if (full_time_collect === "false") {
            let from = bike_recogida[4].split('open_time:')[1] + ":00am";
            let to = (parseInt(bike_recogida[5].split("close_time:")[1]) - 12) + ":00pm";
            create_array_for_product('open_time_collect', (bike_recogida[4].split('open_time:')[1].length === 1 ? `0${bike_recogida[4].split('open_time:')[1]}` : bike_recogida[4].split('open_time:')[1]));
            create_array_for_product('close_time_collect', (bike_recogida[5].split('close_time:')[1].length === 1 ? `0${bike_recogida[5].split('close_time:')[1]}` : bike_recogida[5].split('close_time:')[1]));
            text_helper_collect = I18n.t('global.main.form.work_by_hours', { from: from, to: to });
        } else {
            text_helper_collect = I18n.t('global.main.form.work_all_day');
        }
        helper_collect.text(text_helper_collect);
        tootltip_button_collect[0].classList.remove('hide-tooltip');*/

        const dealer_collect = bike_recogida[1].split('dealer:')[1];

        // Cargar modalidades disponibles (envuelto en Promesa para el withElementBlock)
        const loadModalities = () => new Promise((resolve) => {
            $.ajax({
                url: `${location.origin}/${sessionStorage.getItem('locale')}/load_modalities`,
                data: {
                    product_type: create_array_for_product('product_type', '', 'show'),
                    dealer: dealer_collect
                },
                type: 'GET',
                dataType: 'json',
                timeout: 30000,
                success: function (data) {
                    if (data.success) {
                        let text_bike_category = $('#text_bike_category');
                        let helper = $(text_bike_category[0].parentElement).find('.helper-text');

                        if (parseInt(data.count) > 1) {
                            let data_result = [{ id: 0, text: I18n.t('global.main.form.select_modality') }];
                            text_bike_category[0].classList.remove('ocultar');
                            helper[0].innerHTML = "";

                            (data.data || []).forEach(index => {
                                let text_modality_show = index.name.split(" ");
                                text_modality_show.shift();
                                text_modality_show = text_modality_show.join(" ");
                                data_result.push({
                                    id: `${index.code}|${index.name}|${index.id}`,
                                    text: text_modality_show
                                });
                            });

                            bike_category.select2({
                                theme: "bootstrap",
                                placeholder: I18n.t('global.main.form.select_modality'),
                                data: data_result
                            }).prop("disabled", false).on('change', function (e) {
                                let modality_selected = e.target.value.split("|");
                                create_array_for_product('modality_code', modality_selected[0]);
                                create_array_for_product('modalities_name', modality_selected[1]);
                                create_array_for_product('has_modality', true);
                            });
                        } else {
                            text_bike_category[0].classList.add('ocultar');
                            create_array_for_product('modality_code', data.data[0].code);
                            create_array_for_product('modalities_name', data.data[0].name);
                            create_array_for_product('text_category', $(e.target).select2('data')[0].text);
                            create_array_for_product('category', data.product[0].code);

                            setSessionVar('day_delay_rent', data.product[0].reservation_time, 'add', false).then();
                            setSessionVar('day_min_rent', data.product[0].min_length_reservation, 'add', false).then();
                            setSessionVar('day_max_rent', data.product[0].max_length_reservation, 'add', false).then();
                            setSessionVar('use_same_hours', data.product[0].same_hours, 'add', false).then();

                            if (!bike_date_collect[0].value.isEmpty() && data.product[0].same_hours === false) {
                                bike_time_delivery.prop('disabled', false);
                                bike_time_delivery[0].value = '';
                                create_array_for_product('car_time_delivery', '', 'delete');
                            } else if (!bike_date_collect[0].value.isEmpty() && data.product[0].same_hours === true) {
                                bike_time_delivery.prop('disabled', true);
                                bike_time_delivery[0].value = bike_time_collect[0].value;
                                create_array_for_product('car_time_delivery', bike_time_collect[0].value);
                            }

                            bike_date_collect.prop('disabled', false);
                            bike_time_collect.prop('disabled', true);
                            bike_time_collect.prop('readonly', true);

                            flatpickr("#bike_date_collect", {
                                altInput: true,
                                altFormat: "d-m-Y",
                                dateFormat: "Y-m-d",
                                disable: date_disabled,
                                disableMobile: "true",
                                minDate: new Date().fp_incr(parseInt(data.product[0].reservation_time) || 0),
                                maxDate: new Date().fp_incr(180),
                                locale: flatpick_lang
                            });
                        }
                    } else {
                        toastr.warning(data.msg, 'Warning');
                    }
                    resolve();
                },
                error: function () {
                    resolve();
                }
            });
        });

        // Contrato y tarifas (con box_block para el overlay)
        // Contrato y tarifas SIN box_block: el withElementBlock ya cubre el overlay y evita
        // el unblock prematuro del helper; los helpers ya avisan con toastr en error.
        const contractTariff = get_contract(null, dealer_collect).then(gcontract => {
            if (!gcontract.next) {
                return;
            }
            // return la cadena interna: el Promise.all espera hasta que TERMINE la tarifa.
            return get_tariffs(null).then(gtariffs => {
                if (!gtariffs.next) {
                    // el helper ya avisó del error
                }
            });
        });

        // Bloquear hasta que terminen TODAS las llamadas por detrás.
        withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
            Promise.all([loadModalities(), contractTariff]),
            { timeout: 30000 });

        let full_time_val = bike_recogida[3].split('full_time:')[1];
        create_array_for_product('full_time', full_time_val);
    }

    // Fecha collect change
    bike_date_collect.on('change', (e) => {
        bike_time_collect.prop('disabled', false);
        bike_time_collect.prop('readonly', false);

        let min_time = create_array_for_product('open_time_collect', '', 'show');
        let max_time = create_array_for_product('close_time_collect', '', 'show');
        let selected_date = e.target.value.split('-');
        let especial_behavior = false;
        if (`${year}-${month}-${day}` === e.target.value || (year === parseInt(selected_date[0]) && parseInt(month) === parseInt(selected_date[1]) && (parseInt(selected_date[2]) - day) === 1)) {
            especial_behavior = true;
            min_time = `${hour}:${minutes}`;
            max_time = "23:55";
        }

        if (create_array_for_product('full_time', '', 'show') === "false") {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",
                minTime: `${min_time}:00`,
                maxTime: `${max_time}:00`
            });
        } else {
            if (especial_behavior) {
                flatpickr(".timepicker", {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    defaultDate: min_time,
                    altFormat: "H:i",
                    time_24hr: true,
                    locale: flatpick_lang,
                    disableMobile: "true",
                    minTime: min_time,
                    maxTime: max_time
                });
            } else {
                flatpickr(".timepicker", {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    defaultDate: min_time,
                    altFormat: "H:i",
                    time_24hr: true,
                    locale: flatpick_lang,
                    disableMobile: "true"
                });
            }
        }

        // verificar temporada
        verify_season(e.target.value).then(vs => {
            let max_date = 0;
            let min_date = 0;

            // FIX (2026-08-11): guard NaN (ver car.js) — si day_min_rent/day_max_rent no están
            // en sessionStorage, parseInt da NaN y flatpickr lanza "Invalid date provided".
            if (vs.length > 0) {
                max_date = parseInt(vs[0].max) + 1;
                min_date = parseInt(vs[0].min) + 1;
            } else {
                max_date = parseInt(sessionStorage.getItem('day_max_rent')) + 1;
                min_date = parseInt(sessionStorage.getItem('day_min_rent')) + 1;
            }
            if (Number.isNaN(min_date)) { min_date = 0; }
            if (Number.isNaN(max_date) || max_date < min_date) { max_date = 180; }
            bike_date_delivery.prop('disabled', false);
            flatpickr("#bike_date_delivery", {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disableMobile: "true",
                disable: date_disabled,
                minDate: new Date(e.target.value).fp_incr(min_date),
                maxDate: new Date(e.target.value).fp_incr(max_date),
                locale: flatpick_lang
            });

            if (sessionStorage.getItem('use_same_hours') !== 'true') {
                bike_time_delivery.prop('disabled', false);
            }
        });
    });

    bike_time_collect.on('change', (e) => {
        if (sessionStorage.getItem('use_same_hours') === 'true') {
            bike_time_delivery[0].value = e.target.value;
            create_array_for_product('car_time_delivery', e.target.value);
        }
    });
}

/* Bike como antes el Suv Urban */
/*
let bike_to, bike_destino, bike_recogida, bike_entrega;
bike_to = $('#bike_to');
let bike_select_collect = $('#bike_collect_place');
let bike_select_delivery = $('#bike_delivery_place');
let bike_collect = bike_select_collect.prop('disabled', true).select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_office')
});
let bike_delivery = bike_select_delivery.prop('disabled', true).select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_office')
});
let bike_category = $('#bike_category').prop('disabled', true).select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_category')
});

bike_to.select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_destiny'), ajax: {
        url: `${location.origin}/${locale.locale}/destination`,
        dataType: "json",
        language: "es",
        data: function (params) {
            return {
                // form_type: form_type_send[0].dataset.type,
                form_type: form_type_send.val(),
                search: params.term,
                page: params.page || 1
            }
        },
        type: 'GET',
        processResults: function (data, params) {
            let result = [];
            params.page = params.page || 1;

            data.rows.map((elem, key) => {
                result.push({
                    id: elem.code + '|' + elem.id, text: elem.name
                })
            })

            if (data.total > 10) {
                if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                    return {
                        results: result, "pagination": {
                            "more": true
                        }
                    }
                } else {
                    return {
                        results: result, "pagination": {
                            "more": false
                        }
                    }
                }
            } else {
                return {
                    results: result, "pagination": {
                        "more": false
                    }
                }
            }
        }
    }
}).on('change', function (e) {
    //LIMPIAR SELECT2
    bike_collect.empty();
    bike_delivery.empty();
    bike_category.empty();
    //FIN DE LIMPIEZA

    let split = e.target.value.split('|');
    bike_destino = split[0]
    let destino_id = split[1]
    create_array_for_product('product_type', form_type_send[0].value);
    create_array_for_product('destination', bike_destino);
    create_array_for_product('amount', 1);
    create_array_for_product('pax', 1);
    create_array_for_product('destination_id', e.target.value.split("|")[1]);
    create_array_for_product('text_destination', $(e.target).select2('data')[0].text);

    bike_delivery.select2({
        theme: "bootstrap",
        language: "es",
        placeholder: I18n.t('global.main.form.select_office'),
        ajax: {
            url: `${location.origin}/${locale.locale}/office_by_destination`,
            data: function (params) {
                return {
                    /!*search: params.term, page: params.page || 1,
                    type: form_type_send[0].dataset.type*!/
                    search: params.term, page: params.page || 1, destination: destino_id,
                    type: form_type_send[0].dataset.type
                }
            },
            type: "GET",
            processResults: function (data, params) {
                let result = [];
                data.offices.map((elem, key) => {
                    let aux = {
                        text: elem.dealer_name, children: []
                    };

                    if (elem.offices.length > 0) {
                        elem.offices.map((child, number) => {
                            if (child.active) {
                                aux.children.push({
                                    id: child.code + '-dealer:' + elem.dealer_code + '-dealer_name:' + elem.dealer_name.replace(/-/g, '_') + '-full_time:' + child.full_time + '-open_time:' + child.open_time + '-close_time:' + child.close_time,
                                    text: child.name
                                });
                            }
                        })

                        result.push(aux);
                    }
                })

                if (result.length === 0) {
                    result.push({
                        text: "No hay datos para mostrar", children: []
                    });
                }

                return {
                    results: result
                }
            }
        }
    }).prop("disabled", false).on('change', function (e) {
        bike_entrega = e.target.value;
        bike_entrega = bike_entrega.split('-');

        create_array_for_product('drop_off_place', bike_entrega[0]);
        create_array_for_product('delivery_place_text', $(e.target).select2('data')[0].text);

        let helper_delivery = $(bike_delivery[0].parentNode).find('.helper-text');
        let tootltip_button_delivery = $(bike_delivery[0].parentNode).find('.tooltip-button');
        let text_helper = '';
        let full_time = bike_entrega[3].split('full_time:')[1];
        if (full_time === "false") {
            let from = bike_entrega[4].split('open_time:')[1] + ":00am";
            let to = (parseInt(bike_entrega[5].split("close_time:")[1]) - 12) + ":00pm";
            text_helper = I18n.t('global.main.form.work_by_hours', {from: from, to: to});
        } else {
            text_helper = I18n.t('global.main.form.work_all_day');

        }
        helper_delivery.text(text_helper);
        tootltip_button_delivery[0].classList.remove('hide-tooltip');

        $(`#bike_date_collect`).prop('disabled', true);
        $(`#bike_time_collect`).prop('disabled', true);
    });

    bike_collect.select2({
        theme: "bootstrap",
        language: "es",
        placeholder: I18n.t('global.main.form.select_office'),
        ajax: {
            url: `${location.origin}/${locale.locale}/office_by_destination`,
            data: function (params) {
                return {
                    search: params.term, page: params.page || 1, destination: destino_id,
                    type: form_type_send[0].dataset.type
                }
            },
            type: "GET",
            processResults: function (data, params) {
                let result = [];
                data.offices.map((elem, key) => {
                    let aux = {
                        text: elem.dealer_name, children: []
                    };

                    if (elem.offices.length > 0) {
                        elem.offices.map((child, number) => {
                            if (child.active) {
                                aux.children.push({
                                    id: child.code + '-dealer:' + elem.dealer_code + '-dealer_name:' + elem.dealer_name.replace(/-/g, '_') + '-full_time:' + child.full_time + '-open_time:' + child.open_time + '-close_time:' + child.close_time,
                                    text: child.name
                                });
                            }
                        })

                        result.push(aux);
                    }
                })

                if (result.length === 0) {
                    result.push({
                        text: "No hay datos para mostrar", children: []
                    });
                }

                return {
                    results: result
                }
            }
        }
    }).prop("disabled", false).on('change', function (e) {
        bike_recogida = e.target.value;
        bike_recogida = bike_recogida.split('-');

        let bike_time_collect = $('#bike_time_collect');
        bike_time_collect.prop('readonly', true);

        create_array_for_product('pick_up_place', bike_recogida[0]);
        create_array_for_product('dealer', bike_recogida[1].split('dealer:')[1]);
        create_array_for_product('dealer_name', bike_recogida[2].split('dealer_name:')[1]);
        create_array_for_product('collect_place_text', $(e.target).select2('data')[0].text);

        let helper = $(bike_collect[0].parentNode).find('.helper-text');
        let tootltip_button = $(bike_collect[0].parentNode).find('.tooltip-button');
        /!*let tootltip_button = $('#bike_collect_place option[value="' + bike_recogida.join('-') + '"]')[0].parentNode.parentNode.querySelector('.tooltip-button');*!/
        let text_helper = '';

        //ESTO ES TEMPORAL
        bike_category.select2({
            theme: "bootstrap", placeholder: I18n.t('global.main.form.select_category'), ajax: {
                url: `${location.origin}/${locale.locale}/service_by_dealer`,
                data: function (params) {
                    return {
                        // form_type: form_type_send[0].dataset.type,
                        form_type: form_type_send[0].value,
                        search: params.term,
                        page: params.page || 1,
                        dealer: bike_recogida[1].split('dealer:')[1]
                    }
                },
                type: "GET",
                processResults: function (data, params) {
                    let result = [];

                    categories = data;
                    if (data.services.length > 0) {
                        let aux = {
                            text: data.dealer_name, children: []
                        };

                        data.services.map((child, number) => {
                            if (child !== null) {
                                if (child.booking_type === 'other' || (child.booking_type === 'car' && child.tipo === 'bike')) {
                                    aux.children.push({
                                        id: child.code, text: child.name
                                    });
                                }
                            }
                        })
                        result.push(aux);

                        return {
                            results: result
                        }
                    } else {
                        return {
                            results: [{
                                text: "No hay datos para mostrar", children: []
                            }]
                        }
                    }
                }
            }
        }).prop("disabled", false).on('change', function (e) {
            create_array_for_product('category', e.target.value);

            /!*get_modalities(null, bike_recogida[1].split('dealer:')[1], 'code', e.target.value, form_type_send[0].dataset.type).then(gmodality => {*!/
            get_modalities(null, bike_recogida[1].split('dealer:')[1], e.target.value).then(gmodality => {

            })

            get_contract(bike_recogida[1].split('dealer:')[1]).then(gcontract => {
                if (!gcontract.next) {
                    toastr.error(I18n.t('main.header.shopping_cart.selling_contract_text'), I18n.t('main.header.shopping_cart.selling_contract'));
                    return;
                }
                get_tariffs(null).then(gtariffs => {
                    if (!gtariffs.next) {
                        toastr.error(I18n.t('main.header.shopping_cart.selling_price_text'), I18n.t('main.header.shopping_cart.selling_price'));
                        return;
                    }

                })
            })

            create_array_for_product('text_category', $(e.target).select2('data')[0].text);

            categories_details(e.target.value).then(category_details => {
                let bike_date_collect = $('#bike_date_collect');
                let bike_time_delivery = $('#bike_time_delivery');
                let bike_time_collect = $('#bike_time_collect');
                setSessionVar('day_delay_rent', category_details.reservation_time, 'add', false).then();
                setSessionVar('day_min_rent', category_details.min_length_reservation, 'add', false).then();
                setSessionVar('day_max_rent', category_details.max_length_reservation, 'add', false).then();
                // setSessionVar('category_description', category_details.description, 'add', false);
                setSessionVar('use_same_hours', category_details.same_hours, 'add', false).then();

                if (!bike_date_collect[0].value.isEmpty() && category_details.same_hours === false) {
                    bike_time_delivery.prop('disabled', false);
                    bike_time_delivery[0].value = '';
                    // setSessionVar('bike_time_delivery', '', 'delete', false).then();
                    create_array_for_product('car_time_delivery', '', 'delete')
                } else {
                    if (!bike_date_collect[0].value.isEmpty() && category_details.same_hours === true) {
                        bike_time_delivery.prop('disabled', true);
                        bike_time_delivery[0].value = bike_time_collect[0].value;
                        // setSessionVar('bike_time_delivery', bike_time_collect[0].value, 'add', false).then()
                        create_array_for_product('car_time_delivery', bike_time_collect[0].value);
                    }
                }

                bike_date_collect.prop('disabled', false);
                bike_time_collect.prop('disabled', false);
                bike_time_collect.prop('readonly', true);

                flatpickr("#bike_date_collect", {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    disable: date_disabled,
                    disableMobile: "true",
                    minDate: new Date().fp_incr(parseInt(category_details.reservation_time)),
                    maxDate: new Date().fp_incr(180),
                    locale: flatpick_lang
                });
            })
        })
        //    HASTA AQUI ES EL TEMPORAL

        let full_time = bike_recogida[3].split('full_time:')[1];
        if (full_time === "false") {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",
                minTime: bike_recogida[4].split('open_time:')[1] + ":00",
                maxTime: bike_recogida[5].split('close_time:')[1] + ":00",
            })

            let from = bike_recogida[4].split('open_time:')[1] + ":00am";
            let to = (parseInt(bike_recogida[5].split("close_time:")[1]) - 12) + ":00pm";
            text_helper = I18n.t('global.main.form.work_by_hours', {from: from, to: to});
            // text_helper = "Esta oficina trabaja en el horario de 0" + recogida[4].split('open_time:')[1] + ":00am a " + (parseInt(recogida[5].split("close_time:")[1]) - 12) + ":00pm ";
        } else {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",
            })

            text_helper = I18n.t('global.main.form.work_all_day');
        }

        helper.text(text_helper);
        tootltip_button[0].classList.remove('hide-tooltip');

        $(`#bike_date_collect`).prop('disabled', true);
        $(`#bike_time_collect`).prop('disabled', true);
    });
});

$('#bike_date_collect').on('change', (e) => {
    //ESTABLECER HORAS SELECCIONABLES EN DEPENDENCIA DEL DIA QUE SE SELECCIONE
    let min_time = create_array_for_product('open_time', '', 'show');
    let max_time = create_array_for_product('close_time', '', 'show');
    let selected_date = e.target.value.split('-');
    let especial_behavior = false;
    if (`${year}-${month}-${day}` === e.target.value || (year === parseInt(selected_date[0]) && parseInt(month) === parseInt(selected_date[1]) && (parseInt(selected_date[2]) - day) === 1)) {
        especial_behavior = true;
        min_time = `${hour}:${minutes}`;
        max_time = "23:55";
    }

    if (create_array_for_product('full_time', '', 'show') === "false") {
        flatpickr(".timepicker", {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            // defaultDate: `${hour}:${minutes}`,
            altFormat: "H:i",
            time_24hr: true,
            locale: flatpick_lang,
            disableMobile: "true",
            minTime: min_time,
            maxTime: max_time,
        })
    } else {
        if (especial_behavior) {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                defaultDate: min_time,
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",
                minTime: min_time,
                maxTime: max_time,
            })
        } else {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                defaultDate: min_time,
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",

            })
        }
    }
    //FIN DE HORAS

    //VERIFICAR TEMPORADA
    verify_season(e.target.value).then(vs => {
        let max_date = 0;
        let min_date = 0;

        if (vs.length > 0) {
            max_date = parseInt(vs[0].max) + 1;
            min_date = parseInt(vs[0].min) + 1;
        } else {
            max_date = parseInt(sessionStorage.getItem('day_max_rent')) + 1;
            min_date = parseInt(sessionStorage.getItem('day_min_rent')) + 1;
        }
        $('#bike_date_delivery').prop('disabled', false);
        flatpickr("#bike_date_delivery", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            disableMobile: "true",
            disable: date_disabled,
            minDate: new Date(e.target.value).fp_incr(min_date),
            maxDate: new Date(e.target.value).fp_incr(max_date),
            locale: flatpick_lang
        });

        if (sessionStorage.getItem('use_same_hours') !== 'true') {
            $('#bike_time_delivery').prop('disabled', false);
        }

    });
})
$('#bike_time_collect').on('change', (e) => {
    if (sessionStorage.getItem('use_same_hours') === 'true') {
        let bike_time_delivery = $('#bike_time_delivery');
        bike_time_delivery[0].value = e.target.value;
        // setSessionVar('time_delivery', e.target.value, 'add', false).then()
        create_array_for_product('car_time_delivery', e.target.value);
    }
})*/
